import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const noteBankApi = createApi({
  reducerPath: "noteBankApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getNote", "getNoteById"],
  endpoints: (builder) => ({
    getNote: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getNote"],
      method:"GET"
    }),
    getNoteById: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getNoteById"],
    }),

    createNote: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["createNote"],
    }),

    updateNote: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
      invalidatesTags: ["updateNote"],
    }),
  }),
});

export const {
  useCreateNoteMutation,
  useGetNoteQuery,
  useGetNoteByIdQuery,
  useUpdateNoteMutation,
} = noteBankApi;
